var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.PgSpan,{staticClass:"pg-click-to-router-by-biz",class:{ 'pg-click-to-router-by-biz__pointer': !!_vm.value },on:{"click":_setup.toRouter}},[_vm._v(_vm._s(_vm.value ?? '-'))])
}
var staticRenderFns = []

export { render, staticRenderFns }